var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2C4.3 2 5 2.7 5 3.5v.6C6.3 2.8 8.1 2 10.1 2c3 0 5.6 1.9 6.8 4.4.4.8 0 1.8-.8 2.1-.8.4-1.8 0-2.2-.8-.8-1.6-2.2-2.6-3.8-2.6-1.4.1-2.6.8-3.4 1.9h1.8c.8 0 1.5.7 1.5 1.5S9.3 10 8.5 10H2V3.5C2 2.7 2.7 2 3.5 2zM15 16.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V10h-6.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h1.8c-.8 1.1-2.1 1.8-3.4 1.8-1.6 0-3.1-1-3.8-2.6-.4-.8-1.3-1.1-2.2-.8-.8.4-1.2 1.3-.8 2.1C4.4 16.1 6.9 18 9.9 18c2 0 3.7-.8 5.1-2.1v.6z"
  })));
};
export default SvgSync;